import initJsModalSubmitReview from "./initJsModalSubmitReview";
import initJsModalSubmitOrder from "./initJsModalSubmitOrder";

async function pasteModalInDom(modalId, query = {}) {
    try {
        if (!modalId) return false;
        if (document.getElementById(modalId)) return true;

        const params = new URLSearchParams();

        Object.entries(query).forEach(([key, value]) => {
            const isArray = Array.isArray(value);
            const values = isArray ? value : [value];
            values.forEach((v) => {
                if (v == null || v === "") return;
                params.append(isArray ? `${key}[]` : key, String(v));
            });
        });

        const queryString = params.toString();
        const url = `/modals/${encodeURIComponent(modalId)}${queryString ? `?${queryString}` : ""}`;

        const res = await fetch(url, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        });

        if (!res.ok) return false;

        const data = await res.json();
        if (!data || typeof data.html !== "string" || !data.html.trim()) return false;

        document.body.insertAdjacentHTML("beforeend", data.html);
        initJsModalSubmitOrder();
        initJsModalSubmitReview();
        return !!document.getElementById(modalId);
    } catch (error) {
        console.error(error);
    }
}

export default pasteModalInDom;
